export default __webpack_public_path__ + "static/media/degenhouse.3c27d4ad.png";